import Vue from 'vue';
import Vuex from 'vuex';
import getters from "@/store/getters";
import * as actions from './actions';
import * as mutations from './mutations';
import { Notice } from 'view-design';

Vue.prototype.$Notice = Notice
Vue.use(Vuex);// 将Vuex挂载到Vue
let store = new Vuex.Store({
    state: {
        userInfo: { // 用户信息
            UserName: ''
        },
        RegisterFlag:{
            flag: false,
            flag2: false,
        },
        forgetFlag: {
            flag2: false
        },
        taskMD5List:[],
        SystemList:{},
        moduleSystem:{},
        isDownLoadM: true,
        historybyperson:{},
        TrialAccount:false,
    },
    mutations:{
        ...mutations,
        setTrialAccount(state, TrialAccount){
            state.TrialAccount = TrialAccount
        },
        setUserInfo(state, userInfo){
            state.userInfo = userInfo
        },
        setRegisterFlag(state, RegisterFlag){
            state.RegisterFlag = RegisterFlag
        },
        setForgetFlag(state, ForgetFlag) {
            state.forgetFlag = ForgetFlag
        },
        setIsDownLoadM(state,val){
            state.isDownLoadM = val
        },
        sethistorybyperson(state,historybyperson){
            state.historybyperson = historybyperson
        },
    },
    actions:{
        ...actions
    },
    getters
});

export default store

